import React from 'react';

const ENTER_KEY_CODE = 13;
const ESC_KEY_CODE = 27;

export default class OrderTextInput extends React.Component {
  state = {
    isEditing: false,
    text: this.props.initialValue || '',
  }

  _commitChanges = () => {
    const newText = this.state.text.trim();
    if (newText === '' && this.props.deleteOnEmpty) {
      if (this.props.onDelete) {
        this.props.onDelete();
      }
    } else if (newText !== this.props.initialValue || (newText === '' && !this.props.initialValue)) {
      let finalName = newText;
      if (finalName === '') {
        const date = new Date();
        finalName = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
      }
      this.props.onSave(finalName);
      this.setState({ text: '' });
    } else {
      if (this.props.onCancel) {
        this.props.onCancel();
      }
    }
  }

  render() {
    return (
      <input
        className={this.props.className}
        onChange={(e) => {
          this.setState({ text: e.target.value });
        }}
        onFocus={() => {
          if (!this.state.text && !this.props.initialValue) {
            const date = new Date();
            const dateStr = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`;
            const timeStr = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
            this.setState({ text: `${dateStr} ${timeStr} Uhr - ` });
          }
        }}
        onKeyDown={(e) => {
          if (this.props.onCancel && e.keyCode === ESC_KEY_CODE) {
            this.props.onCancel();
          } else if (e.keyCode === ENTER_KEY_CODE) {
            this._commitChanges();
          }
        }}
        placeholder={this.props.placeholder}
        value={this.state.text}
      />
    );
  }
}
